import { TestCasesFilterSettings } from './TestCasesFilterSettings';
import { TestPlansFilterSettings } from './TestPlansFilterSettings';
import { TestRunsFilterSettings } from './TestRunsFilterSettings';

export const AutoCreateTestRuns = {
    TestPlansFilterSettings,
    TestRunsFilterSettings,
    TestCasesFilterSettings,
};
